import React from 'react';
import KpiDashboardExportMenu from './KpiDashboardExportMenu';
import { SectionLabel } from './KpiDashboardContent';

export interface MsrReportSlideProps {
  id: string;
  title: string;
  /** Retained for export filenames; customer is shown once in the MSR tab header. */
  customerName?: string;
  children: React.ReactNode;
  observation?: React.ReactNode;
  /** MSR-only: per-section export actions */
  onExportPdf?: () => void;
  onExportExcel?: () => void;
  exportLoading?: boolean;
  exportDisabled?: boolean;
}

/** MSR report section — same section rhythm as other KPI dashboard tabs (export capture target). */
const MsrReportSlide: React.FC<MsrReportSlideProps> = ({
  id,
  title,
  children,
  observation,
  onExportPdf,
  onExportExcel,
  exportLoading = false,
  exportDisabled = false,
}) => (
  <section id={id} className="mb-8">
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div className="min-w-0 flex-1">
        <SectionLabel id={`${id}-heading`}>{title}</SectionLabel>
      </div>
      {onExportPdf && onExportExcel ? (
        <div className="mb-3 shrink-0">
          <KpiDashboardExportMenu
            disabled={exportDisabled}
            loading={exportLoading}
            onExportPdf={onExportPdf}
            onExportExcel={onExportExcel}
            ariaLabel={`Export ${title}`}
            triggerLabel="Export section"
          />
        </div>
      ) : null}
    </div>
    {children}
    {observation}
  </section>
);

export default MsrReportSlide;
